import React from 'react';
import {View} from 'react-native';

/**
 * The four heights of the Figma `SpacerMob` component. Layouts in the rewards
 * sign-up flow are spacer-driven rather than margin-driven, so these are the
 * only vertical gaps the design uses.
 */
export type SpacerSize = 16 | 24 | 40 | 64;

export interface SpacerProps {
  size: SpacerSize;
}

const Spacer = ({size}: SpacerProps) => <View style={{height: size}} />;

export default Spacer;
